import { render, staticRenderFns } from "./AddressString.vue?vue&type=template&id=be105272&scoped=true&"
import script from "./AddressString.vue?vue&type=script&lang=js&"
export * from "./AddressString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be105272",
  null
  
)

export default component.exports